import { JAVA_SVC } from "../../../config";
import { apiFetch } from "../../../services/httpClient";
import { localStoragePrefix } from "../../../utils/GeneralFunc";
import { uiActions } from "../ui/ui-slice";
import { cartAction } from "./cart-slice";

// Action creators or Thunks outside the component

export const fetchCartData = () => {
  const userData = JSON.parse(
    localStorage.getItem(`${localStoragePrefix}user`)
  );
  return async (dispatch) => {
    const fetchData = async () => {
      const response = await apiFetch(
        `/carts/getusercartbystatus?userid=${userData.id}&status=1`
      );
      if (!response.ok) {
        throw new Error("fetching cart data failed!");
      }
      const data = await response.json();

      return data;
    };

    try {
      const cartData = await fetchData();

      dispatch(
        cartAction.replaceCart({
          items: cartData.cartDetails || [],
          cart: cartData || [],
        })
      );
    } catch (error) {
      dispatch(
        cartAction.replaceCart({
          items: [],
          cart: [],
        })
      );
      // console.log("---CART ITEMS NOT FOUND---");
    }
  };
};
export const sendCartData = (cartItems) => {
  return async (dispatch) => {
    dispatch(uiActions.InLoadingState());
    const sendRequest = async () => {
      const response = await apiFetch(`/cartdetails`, {
        method: "POST",
        body: JSON.stringify(cartItems),
      
      });
      if (!response.ok) {
        throw new Error("sending cart data failed!");
      }
    };

    try {
      await sendRequest();

      function setTimeoutPromise(delay) {
        return new Promise((resolve, reject) => {
          setTimeout(() => {
            dispatch(cartAction.cartDataChanged());
            resolve(`wait for ${delay} milliseconds `);
            // reject("Error!");
          }, delay);
        });
      }

      setTimeoutPromise(1500).then((msg) => {
        console.log(msg);
        dispatch(uiActions.CloseLoadingState());
      });

      console.log("sent cart data successfully!");
    } catch (error) {
      dispatch(uiActions.CloseLoadingState());
      console.log(error);
    }
  };
};
// export const sendUpdateCartData = (cartItems) => {
//   return async (dispatch) => {
//     dispatch(uiActions.InLoadingState());
//     const sendRequest = async () => {
//       const response = await apiFetch(`/cartdetails/updatecartitem`, {
//         method: "POST",
//         body: JSON.stringify(cartItems),
//         headers: {
//           "Content-Type": "application/json",
//         },
//       });
//       if (!response.ok) {
//         throw new Error("update cart data failed!");
//       }
//     };

//     try {
//       await sendRequest();

//       function setTimeoutPromise(delay) {
//         return new Promise((resolve, reject) => {
//           setTimeout(() => {
//             dispatch(cartAction.cartDataChanged());
//             resolve(`wait for ${delay} milliseconds `);
//             // reject("Error!");
//           }, delay);
//         });
//       }

//       setTimeoutPromise(250).then((msg) => {
//         console.log(msg);
//         dispatch(uiActions.CloseLoadingState());
//       });
//       console.log("update cart data successfully!");
//     } catch (error) {
//       dispatch(uiActions.CloseLoadingState());
//       console.log(error);
//     }
//   };
// };
// export const createCartDetail = (cartDetails) => {
//   return async (dispatch) => {
//     dispatch(uiActions.InLoadingState());
//     const sendRequest = async () => {
//       const response = await apiFetch(`/carts`, {
//         method: "POST",
//         body: JSON.stringify(cartDetails),
//         headers: {
//           "Content-Type": "application/json",
//         },
//       });
//       if (!response.ok) {
//         throw new Error("create cart with details failed!");
//       }
//     };

//     try {
//       await sendRequest();
//       function setTimeoutPromise(delay) {
//         return new Promise((resolve, reject) => {
//           setTimeout(() => {
//             dispatch(cartAction.cartDataChanged());
//             resolve(`wait for ${delay} milliseconds `);
//             // reject("Error!");
//           }, delay);
//         });
//       }

//       setTimeoutPromise(250).then((msg) => {
//         console.log(msg);
//         dispatch(uiActions.CloseLoadingState());
//       });
//       console.log("create cart with details successfully!");
//     } catch (error) {
//       dispatch(uiActions.CloseLoadingState());
//       console.log(error);
//     }
//   };
// };

export const sendUpdateCartData =
  (cartItems, toastCtx, messages = {}) => {
    return async (dispatch) => {
      dispatch(
        uiActions.InLoadingState()
      );

      try {
        // =========================
        // API CALL
        // =========================
        const response = await apiFetch(
          `/cartdetails/updatecartitem`,
          {
            method: "PATCH",
          
            body: JSON.stringify(
              cartItems
            ),
          }
        );

        // =========================
        // ERROR HANDLING
        // =========================
        if (!response.ok) {
          let errorMessage =
            "Update cart failed";

          try {
            const err =
              await response.json();

            errorMessage =
              err?.message ||
              errorMessage;
          } catch {}

          throw new Error(
            errorMessage
          );
        }

        // =========================
        // RESPONSE
        // =========================
        let data = null;

        try {
          data =
            await response.json();
        } catch {}

        // =========================
        // UPDATE CART STATE
        // =========================
        dispatch(
          cartAction.cartDataChanged()
        );

        // =========================
        // SUCCESS TOAST
        // =========================
        toastCtx?.open?.(
          messages.success ||
            "Cart updated successfully!"
        );

        return data;
      } catch (error) {
        console.error(error);

        // =========================
        // ERROR TOAST
        // =========================
         toastCtx?.open?.(
          messages.error ||
            error.message ||
            "Something went wrong"
        );

        throw error;
      } finally {
        dispatch(
          uiActions.CloseLoadingState()
        );
      }
    };
  };
export const createCartDetail =
  (cartDetails, toastCtx) => {
    return async (dispatch) => {
      dispatch(
        uiActions.InLoadingState()
      );

      try {
        const response = await apiFetch(
          `/carts`,
          {
            method: "POST",
           
            body: JSON.stringify(
              cartDetails
            ),
          }
        );

        if (!response.ok) {
          let errorMessage =
            "Failed to add item to cart";

          try {
            const err =
              await response.json();

            errorMessage =
              err?.message ||
              errorMessage;
          } catch {}

          throw new Error(
            errorMessage
          );
        }

        const data =
          await response.json();

        dispatch(
          cartAction.cartDataChanged()
        );

        // ✅ SUCCESS TOAST (SERVICE LEVEL)
        toastCtx.open(
          "Added to cart successfully!"
        );

        return data;
      } catch (error) {
        console.error(error);

        // ❌ ERROR TOAST (SERVICE LEVEL)
        toastCtx.open(
          error.message ||
            "Something went wrong"
        );

        throw error;
      } finally {
        dispatch(
          uiActions.CloseLoadingState()
        );
      }
    };
  };
export const deleteItemFromCart = (cartId) => {
  return async (dispatch) => {
    dispatch(uiActions.InLoadingState());
    const sendRequest = async () => {
      const response = await apiFetch(`/cartdetails/${cartId}`, {
        method: "DELETE",
        body: cartId,
        
      });
      if (!response.ok) {
        throw new Error("delete cart detail failed!");
      }
    };

    try {
      await sendRequest();
      function setTimeoutPromise(delay) {
        return new Promise((resolve, reject) => {
          setTimeout(() => {
            dispatch(cartAction.cartDataChanged());
            resolve(`wait for ${delay} milliseconds `);
            // reject("Error!");
          }, delay);
        });
      }

      setTimeoutPromise(250).then((msg) => {
        console.log(msg);
        dispatch(uiActions.CloseLoadingState());
      });
      console.log("delete cart detail successfully!");
    } catch (error) {
      dispatch(uiActions.CloseLoadingState());
      console.log(error);
    }
  };
};
export const deleteSelectedCartDetails = (ids) => {
  return async (dispatch) => {
    dispatch(uiActions.InLoadingState());
    const sendRequest = async () => {
      const response = await apiFetch(
        `/cartdetails/deleteAllCartDetails/0`,
        {
          method: "DELETE",
          body: JSON.stringify(ids),
          
        }
      );
      if (!response.ok) {
        throw new Error("delete cart detail failed!");
      }
    };

    try {
      await sendRequest();
      function setTimeoutPromise(delay) {
        return new Promise((resolve, reject) => {
          setTimeout(() => {
            dispatch(cartAction.cartDataChanged());
            resolve(`wait for ${delay} milliseconds `);
            // reject("Error!");
          }, delay);
        });
      }

      setTimeoutPromise(250).then((msg) => {
        console.log(msg);
        dispatch(uiActions.CloseLoadingState());
      });
      console.log("delete cart detail successfully!");
    } catch (error) {
      dispatch(uiActions.CloseLoadingState());
      console.log(error);
    }
  };
};
